@if (visible) {
  <div class="modal-overlay" (mousedown)="onOverlayClick()">
    <div class="modal-card firmen-card" role="dialog" aria-modal="true"
         aria-labelledby="companies-modal-title"
         (mousedown)="$event.stopPropagation()"
         cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
      <div class="modal-head">
        <div>
          <div class="modal-sub">{{ 'adminDash.companies.sub' | translate }}</div>
          <div class="modal-title" id="companies-modal-title">{{ 'adminDash.companies.title' | translate }}</div>
        </div>
        <button class="modal-x" type="button" [attr.aria-label]="'general.close' | translate" (click)="close()">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor"
               stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6l-12 12"/>
          </svg>
        </button>
      </div>

      <div class="modal-body">
        <p class="edit-intro">{{ 'adminDash.companies.intro' | translate }}</p>
        <p class="au-required-hint">{{ 'adminDash.companies.requiredHint' | translate }}</p>

        <div class="bt-firma-head">
          <span class="bt-firma-count">{{ 'adminDash.companies.summary' | translate: {count: rows.length} }}</span>
          <button class="btn-text accent bt-add" type="button" (click)="addCompany()">
            <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor"
                 stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            {{ 'adminDash.companies.add' | translate }}
          </button>
        </div>

        <div class="au-fgrid-head">
          <span>{{ 'adminDash.companies.col.abbreviation' | translate }}<span class="au-req" aria-hidden="true">*</span></span>
          <span>{{ 'adminDash.companies.col.name' | translate }}<span class="au-req" aria-hidden="true">*</span></span>
          <span>{{ 'adminDash.companies.col.color' | translate }}</span>
          <span>{{ 'adminDash.companies.col.preview' | translate }}</span>
          <span>{{ 'adminDash.companies.col.usage' | translate }}</span>
          <span></span>
        </div>

        @for (c of rows; track c._tempId) {
          <div class="au-frow">
            <input class="bf-input bt-kuerzel-in" type="text" #abbrInput
                   [ngModel]="c.abbreviation" (ngModelChange)="onAbbrInput(c, $event, abbrInput)"
                   maxlength="4" required
                   [class.bf-input--missing]="isAbbrMissing(c)"
                   [attr.aria-invalid]="isAbbrMissing(c)"
                   [placeholder]="'adminDash.companies.abbrPlaceholder' | translate"
                   [attr.aria-label]="'adminDash.companies.col.abbreviation' | translate">
            <input class="bf-input" type="text"
                   [(ngModel)]="c.name" required
                   [class.bf-input--missing]="isNameMissing(c)"
                   [attr.aria-invalid]="isNameMissing(c)"
                   [placeholder]="'adminDash.companies.namePlaceholder' | translate"
                   [attr.aria-label]="'adminDash.companies.col.name' | translate">
            <div class="au-color-cell">
              <input class="bu-color" type="color" [(ngModel)]="c.color"
                     [attr.aria-label]="'adminDash.companies.colorLabel' | translate">
              <span class="au-hex">{{ hexDisplay(c.color) }}</span>
            </div>
            <span class="au-firma-badge" [ngStyle]="badgeStyle(c.color)" [title]="c.name">
              {{ c.abbreviation }}
            </span>
            <span class="au-usage">{{ 'adminDash.companies.usage' | translate: {userCount: userCountOf(c), advisorCount: advisorCountOf(c)} }}</span>
            <button class="of-del" type="button"
                    [attr.aria-label]="'adminDash.companies.remove' | translate"
                    [title]="'adminDash.companies.remove' | translate"
                    (click)="removeCompany(c)">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
                   stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M4 7h16M10 11v6M14 11v6"/>
                <path d="M6 7l1 13a2 2 0 002 2h6a2 2 0 002-2l1-13"/>
                <path d="M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"/>
              </svg>
            </button>
          </div>
        }
      </div>

      <div class="modal-foot">
        @if (hasIncompleteRows) {
          <span class="modal-count modal-count--error" role="status">
            {{ 'adminDash.companies.incompleteHint' | translate: {rows: incompleteRowLabels} }}
          </span>
        } @else {
          <span class="modal-count">{{ 'adminDash.companies.footHint' | translate }}</span>
        }
        <div class="modal-actions">
          <button class="btn-text" type="button" (click)="cancel()">{{ 'general.cancel' | translate }}</button>
          <button class="btn-primary" type="button" [disabled]="isSaving || hasIncompleteRows"
                  (click)="save()">
            {{ 'general.save' | translate }}
          </button>
        </div>
      </div>

      @if (pendingRemoval) {
        <div class="migrate-overlay" (mousedown)="cancelPendingRemoval()">
          <div class="migrate-card" role="dialog" aria-modal="true"
               (mousedown)="$event.stopPropagation()"
               (keydown.escape)="cancelPendingRemoval()">
            <div class="migrate-head">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor"
                   stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/>
                <path d="M12 9v4M12 17h.01"/>
              </svg>
              {{ 'adminDash.companies.deleteConfirm.title' | translate }}
            </div>
            <p class="migrate-text">
              {{ 'adminDash.companies.deleteConfirm.text' | translate: {
                abbr: pendingRemoval.row.abbreviation || '',
                userWord: (pendingUserCount === 1
                  ? 'adminDash.companies.deleteConfirm.userSingular'
                  : 'adminDash.companies.deleteConfirm.userPlural') | translate: {count: pendingUserCount},
                advisorWord: (pendingAdvisorCount === 1
                  ? 'adminDash.companies.deleteConfirm.advisorSingular'
                  : 'adminDash.companies.deleteConfirm.advisorPlural') | translate: {count: pendingAdvisorCount}
              } }}
            </p>
            <label class="bf-label">
              {{ 'adminDash.companies.deleteConfirm.reassign' | translate }}
              <select class="bf-input" [(ngModel)]="pendingRemoval.targetCompanyId">
                @for (t of migrationTargets(); track t._tempId) {
                  <option [ngValue]="t.id">
                    {{ t.abbreviation || '—' }} — {{ t.name }}
                  </option>
                }
              </select>
            </label>
            <div class="migrate-actions">
              <button class="btn-text" type="button" (click)="cancelPendingRemoval()">
                {{ 'general.cancel' | translate }}
              </button>
              <button class="btn-primary" type="button"
                      [disabled]="!pendingRemoval.targetCompanyId"
                      (click)="confirmPendingRemoval()">
                {{ 'adminDash.companies.deleteConfirm.confirm' | translate }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
